import ErnstigeBloedingenOnderVka from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-vka.json";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderVka,
  React
};